export default __webpack_public_path__ + "static/image-full-50d0bb102c7382b56ee3ad8a1e0970da.jpg";